// Week 6 / Day 4 — Активность, пульс, скорость и график / Activity, Pulse, Speed and Trend
// Solid Grade 6 math + RU Grade 3–4.

export const maxWeek6Day4 = {
  id: 'max-week-6-day-4',
  studentId: 'max',
  weekId: 'week-6',
  dayId: 'day-4',
  title: 'Активность, пульс, скорость и график / Activity, Pulse, Speed and Trend',
  shortTitle: 'Активность и скорость / Activity and Speed',
  theme:
    'Макс анализирует активность, пульс, скорость и тренд по данным. / Max analyses activity, pulse, speed and trend from data.',
  estimatedTimeLabel: 'Онлайн: 25–35 мин. Полный день: 80–100 мин. / Online: 25–35 min. Full day: 80–100 min.',
  nimnyIntro:
    'Нимни ведёт Макса через среднее/медиану/размах, скорость км/ч, процент роста пульса и таблицу тенденций. / Nimny walks Max through mean/median/range, km/h speed, pulse-growth percent and trend tables.',
  goals: [
    'Слой 1. Математика / Layer 1. Math: среднее/медиана/размах, скорость и время, проценты роста, анализ таблицы (Grade 6). / mean/median/range, speed/time, growth percent, table trend.',
    'Слой 2. Русский / Layer 2. Russian: части речи, безударные, исправление.',
    'Слой 3. Чтение и письмо / Layer 3. Reading: короткий текст о движении и данных + план + 4 предложения.',
    'Слой 4. Логика и анализ данных / Layer 4. Logic and data analysis: редкие длинные vs регулярные короткие тренировки.',
    'Слой 5. Практика: свой activity/energy log 5 дней. / Practical: 5-day activity/energy log.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 3/5.'
  ],
  vocabulary: [
    { term: 'пульс / pulse', definition: 'сколько раз сердце бьётся в минуту / heart beats per minute' },
    { term: 'скорость / speed', definition: 'расстояние, делённое на время / distance divided by time' },
    { term: 'километр в час / km/h', definition: 'сколько километров за час / kilometers per hour' },
    { term: 'рост / growth', definition: 'разница нового и старого значения / difference of new and old value' },
    { term: 'таблица / table', definition: 'ряд данных с метками / a labeled series of data' },
    { term: 'тренд / trend', definition: 'направление изменений в данных / direction of changes in data' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Данные активности / Activity data',
      prompt: 'Тренировки: Пн 22, Вт 35, Ср 28, Чт 40, Пт 25 мин. Найди сумму, среднее, медиану и размах. / Find total, mean, median, range.',
      helper: 'Сортируй для медианы. / Sort for median.',
      answer: 'Сумма 150; среднее 30; медиана 28; размах 18. / Sum 150; mean 30; median 28; range 18.', unit: 'мин / min' },
    { id: 'q2', type: 'math', title: 'Скорость км/ч / Speed km/h',
      prompt: 'Макс пробежал 1.2 км за 10 минут. Какая скорость км/ч? Сколько км за 25 минут при той же скорости? / Speed in km/h; distance in 25 min.',
      helper: '10 мин = 1/6 часа. / 10 min = 1/6 h.',
      answer: '7.2 км/ч; 3 км за 25 мин. / 7.2 km/h; 3 km in 25 min.', unit: 'км/ч / km/h' },
    { id: 'q3', type: 'math', title: 'Процент роста пульса / Pulse growth percent',
      prompt: 'Пульс до нагрузки 78 уд/мин, после — 126 уд/мин. На сколько процентов вырос пульс? / Percent growth from 78 to 126.',
      helper: '(126 − 78) ÷ 78. / Change divided by original.',
      answer: 'Рост 48 уд; примерно 61.5%. / +48 bpm; about 61.5%.', unit: '%' },
    { id: 'q4', type: 'math', title: 'Анализ тренда / Trend analysis',
      prompt: 'Энергия: Пн 6, Вт 7, Ср 7, Чт 9, Пт 8. Найди 1) день максимума, 2) самый большой рост, 3) среднее. / Max day; biggest jump; mean.',
      helper: 'Сравнивай день с предыдущим. / Compare each day to previous.',
      answer: 'Максимум Чт (9); самый большой рост Ср→Чт (+2); среднее 7.4. / Thu = 9; +2 Wed→Thu; mean 7.4.', unit: '' },
    { id: 'q5', type: 'classify', title: 'Части речи / Parts of speech',
      prompt: 'Распредели по частям речи. / Sort by part of speech.',
      categories: [
        { id: 'noun', label: 'Существительное / Noun' },
        { id: 'verb', label: 'Глагол / Verb' },
        { id: 'adj', label: 'Прилагательное / Adjective' }
      ],
      items: [
        { id: 'w1', text: 'движение / movement' },
        { id: 'w2', text: 'быстрый / fast' },
        { id: 'w3', text: 'бегать / to run' },
        { id: 'w4', text: 'пульс / pulse' },
        { id: 'w5', text: 'спокойный / calm' },
        { id: 'w6', text: 'измерять / to measure' }
      ] },
    { id: 'q6', type: 'text', title: 'Исправь ошибки / Fix mistakes',
      prompt: 'Перепиши без ошибок: «движэние помагает укреплять серце, а данные показывают прогрес». / Rewrite without mistakes.',
      placeholder: 'Движение помогает... / Movement helps...' },
    { id: 'q7', type: 'text', title: 'Главная мысль и план / Main idea and plan',
      prompt: 'Прочитай текст «Движение и данные» на печатном листе. Запиши главную мысль, план из 3 пунктов и 4 предложения. / Read; main idea, 3-point plan, 4 sentences.',
      placeholder: 'Главная мысль: ... / Main idea: ...' },
    { id: 'q8', type: 'text', title: 'Логика: длинные vs короткие / Logic: long vs short',
      prompt: 'Что лучше для привычки — редкие длинные тренировки или регулярные короткие? Дай 2 причины и пример. / 2 reasons + example.',
      placeholder: 'Регулярные короткие... / Regular short...' },
    { id: 'q9', type: 'essay', title: 'Мой activity/energy log / My activity/energy log',
      prompt: 'Опиши 5 дней: минуты активности и уровень энергии 1–10. Посчитай среднее и найди тренд. / 5 days of activity + energy; mean + trend.',
      minSentences: 4, maxSentences: 8, placeholder: 'Пн: 22 мин, энергия 6...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 6, День 4». / Heading.',
    'Слой 1. Математика: q1 (данные активности), q2 (скорость), q3 (% роста пульса), q4 (тренд). / Math.',
    'Слой 2. Русский: части речи + исправление. / Russian.',
    'Слой 3. Чтение: главная мысль + план + 4 предложения. / Reading.',
    'Слой 4. Логика: аргумент длинные vs короткие. / Logic.',
    'Слой 5. Практика: activity/energy log 5 дней. / Practical.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами. / Reward.'
  ],
  printWorksheet: {
    title: 'Неделя 6, День 4 / Week 6, Day 4',
    subtitle: 'Активность, пульс, скорость и график / Activity, Pulse, Speed and Trend',
    pages: [
      { title: 'Маршрут дня: пять слоёв обучения / Daily route: five learning layers', blocks: [
        { type: 'list', items: [
          '1. Математика / Math — 30–35 мин / min.',
          '2. Русский язык / Russian — 15–20 мин / min.',
          '3. Чтение и письмо / Reading and writing — 10–15 мин / min.',
          '4. Логика и анализ данных / Logic and data analysis — 5–10 мин / min.',
          '5. Практика: activity/energy log / Practical: activity/energy log — 10–15 мин / min.',
          '6. Дневник мышления / Thinking diary — 5 мин / min.',
          '7. Награда нимами / Reward in nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика / Layer 1. Math', blocks: [
        { type: 'text', text: 'Grade 6: анализ данных, скорость, проценты роста, анализ таблицы. Показывай шаги. / Show steps.' },
        { type: 'list', items: [
          '1) Активность 22, 35, 28, 40, 25 мин. Сумма = ____. Среднее = ____ ÷ 5 = ____. Сортировка: ____, ____, ____, ____, ____. Медиана = ____. Размах = ____ − ____ = ____. / Data.',
          '2) 1.2 км за 10 мин. 10 мин = 1/6 ч. Скорость = 1.2 ÷ 1/6 = ____ км/ч. За 25 мин = 25/60 ч; расстояние = ____ × ____ = ____ км. / Speed.',
          '3) Пульс 78 → 126. Рост = ____ уд. Процент роста = ____ ÷ 78 ≈ ____%. / Percent growth.',
          '4) Энергия 6, 7, 7, 9, 8. Максимум = ____ (____). Изменения: Пн→Вт ____; Вт→Ср ____; Ср→Чт ____; Чт→Пт ____. Самый большой рост: ____. Среднее = (6 + 7 + 7 + 9 + 8) ÷ 5 = ____ ÷ 5 = ____. / Trend.',
          '5) Проверка / Check: 22 + 35 + 28 + 40 + 25 = ____ (150 мин)? / Sum check.',
          '6) Если тренировка на 30% дольше 40 мин, новое время = ____ мин. / Grow by 30%.',
          '7) Optional / Доп.: пульс 90 → 108. Процент роста = ____%. / Extra growth.',
          '8) Optional / Доп.: расстояние 2.4 км за 15 мин; скорость км/ч = ____. / Extra speed.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling', blocks: [
        { type: 'text', text: 'Правило / Rule: определяем часть речи по вопросу и роли; проверяем безударные. / Part of speech + unstressed.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: движение, пульс, скорость, тренд, среднее, рост, данные, привычка.',
          'Части речи / Parts of speech: движение, быстрый, бегать, пульс, спокойный, измерять — раздели.',
          'Исправь ошибки / Fix mistakes: «движэние помагает укреплять серце, а данные показывают прогрес».',
          'Мини-диктант / Mini-dictation: «Движение укрепляет сердце, а данные помогают увидеть прогресс».',
          'Орфограмма дня / Spelling rule: жи-ши, ча-ща, чу-щу и безударные проверяемые. / ZHI-SHI, CHA-SHCHA, CHU-SHCHU.'
        ] }
      ] },
      { title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling', blocks: [
        { type: 'list', items: [
          'Текст «Движение и данные» / Text: Движение делает сердце сильнее, а мышцы — выносливее. Но одну тренировку заметить трудно. Данные показывают то, что глаз пропускает: как пульс успокаивается быстрее, как через неделю бег даётся легче. Когда Макс видит цифры, он понимает, что маленькие шаги складываются в большой прогресс. Поэтому наблюдение и запись — часть здоровой привычки. / Movement strengthens the heart and endurance. One session is hard to notice, but data shows what the eye misses. When Max sees the numbers, he sees small steps building progress. Observation and recording are part of a healthy habit.',
          'Главная мысль / Main idea: __________________________________',
          'План из 3 пунктов / 3-point plan: 1) ______ 2) ______ 3) ______',
          '4 своих предложения о движении и данных / 4 sentences: ______________________________',
          'Пересказ родителю 3–5 предложений по-русски / Retell in 3–5 Russian sentences ✓.'
        ] }
      ] },
      { title: 'Слой 4. Логика и анализ данных / Layer 4. Logic and Data Analysis', blocks: [
        { type: 'text', text: 'Сравни: A — тренировка 90 мин раз в неделю; B — 4 тренировки по 25 мин в неделю. / Compare A and B.' },
        { type: 'list', items: [
          'Всего минут в A: ____. Всего минут в B: ____ (4 × 25). Разница: ____ мин. / Totals.',
          'Что лучше приучает тело? / Which trains the body better?',
          'Что легче делать регулярно? / Which is easier to keep regular?',
          'Мой аргумент / My argument: __________________________________',
          'Вывод / Conclusion: регулярные короткие тренировки формируют привычку. / Regular short sessions build habit.'
        ] }
      ] },
      { title: 'Слой 5. Практические знания: activity/energy log / Layer 5. Practical Knowledge: Activity/Energy Log', blocks: [
        { type: 'text', text: 'Это не медицинский совет. Нагрузку выбирает родитель. / Not medical advice. Parent chooses the load.' },
        { type: 'list', items: [
          'Пн / Mon: активность ____ мин; энергия 1–10 = ____.',
          'Вт / Tue: активность ____ мин; энергия 1–10 = ____.',
          'Ср / Wed: активность ____ мин; энергия 1–10 = ____.',
          'Чт / Thu: активность ____ мин; энергия 1–10 = ____.',
          'Пт / Fri: активность ____ мин; энергия 1–10 = ____.',
          'Сумма минут / Total minutes: ____. Среднее энергии / Mean energy: ____.',
          'Тренд энергии по дням / Energy trend day-to-day: ____ (растёт / падает / стабилен) / (up / down / stable).'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Самое важное про движение сегодня / Most important about movement today: ______',
          'Самое важное слово / Most important word: ______'
        ] }
      ] },
      { title: 'Родительская проверка и награда нимами / Parent check and reward in nims', blocks: [
        { type: 'list', items: [
          'Базовая награда / Base reward: 3 нима / nims ✓',
          'Бонус за скорость и % роста / Bonus for speed and growth %: +1 ☐',
          'Бонус за понятный activity/energy log / Bonus for a clear log: +1 ☐',
          'Итого / Total: ____ из / of 5 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Grade 6: анализ данных {22,35,28,40,25} = 150/30/28/18; скорость 7.2 км/ч; % роста ≈ 61.5%; тренд по таблице. / Solid Grade 6 math + Grade 3–4 Russian.',
    mathGoal: 'q1: 150/30/28/18. q2: 7.2 км/ч; 3 км. q3: +48 уд, ~61.5%. q4: Чт=9; Ср→Чт +2; среднее 7.4. / Listed with steps.',
    russianGoal: 'Существительные: движение, пульс. Глаголы: бегать, измерять. Прилагательные: быстрый, спокойный. / Correct parts of speech.',
    readingWritingGoal: 'Главная мысль: данные видят то, что глаз пропускает. План + 4 предложения. / Main idea + plan + 4 sentences.',
    practicalGoal: 'Activity/energy log 5 дней с суммой минут, средней энергией и трендом. / 5-day log with mean and trend.',
    check: [
      'Q1: 150 / 30 / 28 / 18.',
      'Q2: 7.2 км/ч; 3 км за 25 мин.',
      'Q3: +48 уд; ~61.5%.',
      'Q4: Чт максимум 9; Ср→Чт +2; среднее 7.4.',
      'Части речи разобраны. / Parts of speech.',
      'Главная мысль + план + 4 предложения. / Main idea + plan + 4 sentences.',
      'Логика длинные vs короткие. / Long vs short logic.',
      'Log посчитан. / Log computed.'
    ],
    answerKey: [
      { taskId: 'q1', answer: 'Сумма 22+35+28+40+25=150; среднее 150÷5=30; сортировка 22/25/28/35/40; медиана 28; размах 40−22=18.' },
      { taskId: 'q2', answer: '10 мин = 1/6 ч; 1.2 ÷ 1/6 = 7.2 км/ч; 25 мин = 5/12 ч; 7.2 × 5/12 = 3 км.' },
      { taskId: 'q3', answer: '126 − 78 = 48; 48 ÷ 78 ≈ 0.615 = 61.5%.' },
      { taskId: 'q4', answer: 'Максимум Чт = 9; изменения +1/0/+2/−1; самый большой рост Ср→Чт +2; среднее (6+7+7+9+8)÷5 = 37÷5 = 7.4.' },
      { taskId: 'q5', answer: 'Существительные: движение, пульс. Глаголы: бегать, измерять. Прилагательные: быстрый, спокойный.' },
      { taskId: 'q6', answer: 'Движение помогает укреплять сердце, а данные показывают прогресс.' },
      { taskId: 'q7', answer: 'Главная мысль: данные видят то, что глаз пропускает. План: 1) что делает движение; 2) что показывают данные; 3) как маленькие шаги складываются. 4 предложения — открытый ответ.' },
      { taskId: 'q8', answer: '2 причины: регулярность формирует привычку; короткие сессии легче удержать. Пример: 4×25 vs 1×90. / 2 reasons + example.' },
      { taskId: 'q9', answer: 'Открытый ответ: 5 дней активности и энергии; среднее и тренд. / Open answer.' }
    ],
    spellingCheck: 'Части речи разобраны; жи-ши/ча-ща/чу-щу правильно. / Parts of speech + ZHI-SHI.',
    readingCheck: 'Главная мысль ясная; план 3 пункта; 4 предложения; пересказ 3–5 предложений. / Main idea + plan + retelling.',
    notebookCheck: 'Все 5 слоёв заполнены. / All 5 layers.',
    printCheck: 'Все 8 страниц заполнены. / All 8 pages.',
    discussionPrompts: [
      'Как ты понимаешь, что тренировка полезна? / How do you know a session helps?',
      'Что помогает пульсу успокоиться? / What calms the pulse?',
      'Что важнее — длинная тренировка или регулярная? / Long vs regular?',
      'Как отследить прогресс без цифр? / How to track without numbers?'
    ],
    ifEasy: 'Усложни: добавь 6-й день (30 мин, энергия 8) и пересчитай среднее и тренд. / Extend: add a 6th day.',
    ifDifficult: 'Оставь q1 и q2. / Keep q1 and q2.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 3, max: 5,
    label: 'Награда за завершение / Completion reward', display: '3 нима / 3 nims',
    bonuses: [
      { id: 'speed-growth', label: 'Бонус за скорость и % роста / Bonus for speed and growth %', amount: 1 },
      { id: 'clean-log', label: 'Бонус за понятный log / Bonus for a clear log', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q4', 'q7', 'q9'], allowNotebookCompletion: true },
  unlockAfter: { weekId: 'week-6', dayId: 'day-3' },
  nextLessonId: 'max-week-6-day-5'
};

export default maxWeek6Day4;
